/* import __COLOCATED_TEMPLATE__ from './how-pricing-works-link.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();